// extracted by mini-css-extract-plugin
export var closeButton = "_gd-2";
export var closeButtonIcon = "_gd-3";
export var lightboxContent = "_gd-1";
export var lightboxOverlay = "_gd-0";